// extracted by mini-css-extract-plugin
module.exports = {"fazrk7j":"fazrk7j","flags":"flags"};